(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lcds-product-content"] && !Shopify.designMode) return;
  try {
    function lcdsFormatLongParagraphs(root) {
    root.querySelectorAll('.lcds-product-content .lcds-copy p').forEach(function (paragraph) {
      paragraph.classList.toggle('lcds-copy-long', (paragraph.textContent || '').trim().length >= 180);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      lcdsFormatLongParagraphs(document);
    });
  } else {
    lcdsFormatLongParagraphs(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    lcdsFormatLongParagraphs(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
